import { BASE_URL } from '../API/BASE_URL';

export const getSelection = async (id) => {
  const response = await fetch(BASE_URL + `shops/selection/${id}/`, {
    method: 'GET',
  });

  const data = await response.json();
  return data;
};
